<script setup lang="ts">
const props = defineProps<{ title?: string, disabled?: boolean, data?: any, collection?: string }>()

const col = GetCollection(props.collection, props.data) ?? {}
const { viewRoute, singular } = col
</script>

<template>
  <section class="bg-slate-50 px-6 md:px-8 lg:px-10 relative shadow-lg rounded-3xl md:rounded-4xl flex justify-center flex-col overflow-clip py-6 md:py-8 lg:py-10">
    <div class="flex flex-wrap justify-between gap-6 lg:gap-12 h-full">
      <div class="w-full lg:flex-1 flex flex-col h-full" :class="{ 'opacity-50': disabled }">
        <HeadingText v-if="title" tag="h3">
          {{ title }}
        </HeadingText>

        <slot />
      </div>
      <div v-if="$slots.actions || viewRoute" class="w-full lg:w-auto flex flex-col justify-end items-center">
        <slot name="actions" />
        <UButton v-if="viewRoute" :to="viewRoute" icon="ri:arrow-right-line" trailing size="lg" class="self-end">
          View {{ singular }}
        </UButton>
      </div>
    </div>
  </section>
</template>
